import { z } from "zod";
import { GameVer } from "~/util/Lang";

export const CreatePageSchema = z
  .object({
    target: z.discriminatedUnion("_", [
      z.object({
        _: z.literal("item"),
        itemName: z.string(),
      }),
      z.object({
        _: z.literal("npc"),
        npcName: z.string(),
      }),
      z.object({
        _: z.literal("quest"),
        questId: z.number(),
      }),
      z.object({
        _: z.literal("skill"),
        skillId: z.number(),
      }),
      z.object({
        _: z.literal("loc"),
        locName: z.string(),
      }),
      z.object({
        _: z.literal("draft"),
        draftId: z.number().nullable().optional(),
      }),
      z.object({
        _: z.literal("wiki"),
        pageId: z.number(),
      }),
      z.object({
        _: z.literal("publication_wiki"),
        draftId: z.number().nullable().optional(),
      }),
      z.object({
        _: z.literal("publication"),
        draftId: z.number().nullable().optional(),
      }),
    ]),
    wikiSlug: z.string().nullable().optional(),
    titleEn: z.string().nullable().optional(),
    contentEn: z.string().nullable().optional(),
    titleRu: z.string().nullable().optional(),
    contentRu: z.string().nullable().optional(),
    game: GameVer.array(),
    public: z.boolean().optional(),
    deleteDraft: z.boolean().optional(),
    images: z.number().array().optional(),
  })
  .strict();

export type CreatePageSchema = z.infer<typeof CreatePageSchema>;
